import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class CustomProgrammedSystems extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Custom Programmed Systems"
					title={"custom programmed systems"}
					image={require('./image-3.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Custom Software Systems
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							

								<p>Could your business systems be more efficient? How valuable is extra time to your company? A custom programmed system is essentially a way to create streamlined, efficient administration systems to save you time and money.</p>

								<h4>How could you make your systems more efficient?</h4>
								
        <ul class="with-icons">
              <li>How many different systems do you have running at once in your business?</li>
<li>How many man hours would you save if they all spoke to each other autonomously?</li>

        </ul>


    <p>Picture this – your customer goes to your website, likes what they see and books a service, paying online in advance. This booking is then passed on to a work management system, and allocated to one of your service staff’s timetables for the day. An account is created in your accounting software, recording the sale. 
</p>
<p>Each day, your serviceman checks his smart phone which shows all of his scheduled appointments and confirms the times, which sends out SMS alerts to all the customers listed, advising them of his approximate arrival time. He then starts his day, his position monitored by head office through the GPS in his phone. 
</p>


<p>Jobs go as planned, with the serviceman taking ‘before and after’ photos of his work (which are auto-uploaded) and signs off his jobs with a report for each emailed to the customer. At the end of the day when he signs off, your serviceman’s hours are transferred back to the accounting software to prepare his next pay. This is done without any administrative staff being needed at all. 

</p> 

<p>For more information and examples, see our Moshi Industrial Apps website <a href="https://industryapp.moshi.com.au" target="_blank">www.industryapp.moshi.com.au</a>

</p>
<br></br>

<p>
</p>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/domain-address-registration">Domain Address Registration</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/app-development">App Development</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>		
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-hosting">Website Hosting</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-marketing">Email Newsletter Marketing</a>
						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>
<h4>We have a saying in marketing, “The first to the future wins” – and this is the future for most businesses.</h4>
 <h3>Moshi Moshi can help you pave the way to a streamlined, efficient business model. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default CustomProgrammedSystems;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/CustomProgrammedSystems.js